import React, { useRef, useEffect } from "react";
import Globe from "react-globe.gl";

const GlobeAirlines = () => {
  const globeRef = useRef();

  const N = 20;
  const arcsData = [...Array(N).keys()].map(() => ({
    startLat: (Math.random() - 0.5) * 180,
    startLng: (Math.random() - 0.5) * 360,
    endLat: (Math.random() - 0.5) * 180,
    endLng: (Math.random() - 0.5) * 360,
    color: [
      ["red", "white", "blue", "green"][Math.round(Math.random() * 3)],
      ["red", "white", "blue", "green"][Math.round(Math.random() * 3)],
    ],
  }));

  useEffect(() => {
    if (globeRef.current) {
      // Enable auto rotation
      globeRef.current.controls().autoRotate = true;
      globeRef.current.controls().autoRotateSpeed = 0.3;
      globeRef.current.controls().enableZoom = false;

      // Set initial camera position
      globeRef.current.pointOfView({ lat: 0, lng: 0, altitude: 2.5 });
    }
  }, []);

  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "-35%",
          top: 0,
          width: "65%",
          height: "100%",
        }}
      >
        <Globe
          globeImageUrl="//cdn.jsdelivr.net/npm/three-globe/example/img/earth-night.jpg"
          ref={globeRef}
          arcsData={arcsData}
          arcColor={"color"}
          arcDashLength={() => Math.random()}
          arcDashGap={() => Math.random()}
          arcDashAnimateTime={() => Math.random() * 4000 + 500}
          showAtmosphere={true}
          atmosphereColor="#cf2323"
          atmosphereAltitude={0.4}
          width={window.innerWidth * 0.5}
          height={window.innerHeight}
        />
      </div>
    </div>
  );
};

export default GlobeAirlines;
